import React, { createContext, useContext, useMemo } from 'react';
import type { ReactNode } from 'react';

type AppContext = boolean | null;

type Props = {
  children: ReactNode,
  isDelivery: boolean,
  isKiosk: boolean,
  isOpatMode: boolean,
};

export const AppTypeContext = createContext<{ isDelivery: AppContext, isKiosk: AppContext, isOpatMode: AppContext }>({
  isDelivery: null,
  isKiosk: null,
  isOpatMode: null,
});

export const AppTypeProvider = ({ isKiosk, isOpatMode, isDelivery, children }: Props) => {
  const value = useMemo(() => ({ isKiosk, isOpatMode, isDelivery }), [isKiosk, isOpatMode, isDelivery]);

  return <AppTypeContext.Provider value={value}>{children}</AppTypeContext.Provider>;
};

export const useAppType = () => useContext(AppTypeContext);
